import { render } from "./ConfirmButton.vue?vue&type=template&id=497fdc5e&scoped=true"
import script from "./ConfirmButton.vue?vue&type=script&lang=js"
export * from "./ConfirmButton.vue?vue&type=script&lang=js"

import "./ConfirmButton.vue?vue&type=style&index=0&id=497fdc5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-497fdc5e"]])

export default __exports__